import { Route } from '@angular/router';
import {
  PageChangelogComponent,
  PageForbiddenComponent,
  PageLoginComponent,
  PageLoginNfcComponent,
  PageOauth2LandingComponent,
  PagePwdResetComponent,
  PageResetRequestComponent,
} from '@infodata-group/inf-commons-desktop';

import { authorizationGuardFn } from '@infodata-group/inf-commons';

import { ProfileGuard } from './service/profile-guard.service';

export const appRoutes: Route[] = [
  { path: 'login', component: PageLoginComponent },
  { path: 'reset-request', component: PageResetRequestComponent },
  { path: 'oauth2', component: PageOauth2LandingComponent },
  { path: 'auth-nfc', component: PageLoginNfcComponent },
  {
    path: 'login/only-nfc',
    loadComponent: () =>
      import('./page/page-only-nfc/page-only-nfc.component').then(
        (m) => m.PageOnlyNfcComponent,
      ),
  },
  {
    path: 'login/debug-mode',
    loadComponent: () =>
      import('./page/page-login-debug.component').then(
        (m) => m.PageLoginDebugComponent,
      ),
  },
  { path: 'reset-password', component: PagePwdResetComponent },
  {
    path: '',
    loadComponent: () =>
      import('./page/page-main/page-main.component').then(
        (m) => m.PageMainComponent,
      ),
    canActivate: [authorizationGuardFn],
    children: [
      { path: 'changelogs', component: PageChangelogComponent },
      {
        path: 'time',
        loadComponent: () =>
          import(
            './page/page-time-management/page-time-management.component'
          ).then((m) => m.PageTimeManagementComponent),
      },
      {
        path: 'time/:id',
        loadComponent: () =>
          import(
            './page/page-time-management/page-time-management.component'
          ).then((m) => m.PageTimeManagementComponent),
      },
      {
        path: 'team',
        loadComponent: () =>
          import(
            './page/page-team-management/page-team-management.component'
          ).then((m) => m.PageTeamManagementComponent),
      },
      {
        path: 'team/:id/:type',
        loadComponent: () =>
          import(
            './page/page-team-management/page-team-management.component'
          ).then((m) => m.PageTeamManagementComponent),
        canActivate: [ProfileGuard],
      },
      {
        path: 'clock',
        loadComponent: () =>
          import('./page/page-clock/page-clock.component').then(
            (m) => m.PageClockComponent,
          ),
      },
      {
        path: 'clock-report',
        loadComponent: () =>
          import(
            './page/page-clocking-report/page-clocking-report.component'
          ).then((m) => m.PageClockingReportComponent),
      },
      { path: '', redirectTo: 'time', pathMatch: 'full' },
    ],
  },
  { path: '403', component: PageForbiddenComponent },
];
